<template>
  <div style="">
    <component :is="header" v-show="$showHeader"></component>
    <router-view>
    </router-view>
    <FloatChatIcon></FloatChatIcon>
  </div>
</template>

<script>
import FloatChatIcon from "@/components/FloatChatIcon";
import PcHeader from "@/components/Header/PcHeader";
export default {
  name: "App",
  components: {FloatChatIcon,PcHeader},
  data() {
    return {
      routerViewActive: true
    }
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  mounted() {
    // 处理e.path  报错的问题
    this.$nextTick(() => {
      Object.defineProperty(Event.prototype, "path", {
        get() {
          return this.composedPath();
        }
      });
    });

  },
  methods: {
    reload() {
      this.routerViewActive = false
      this.$nextTick(() => {
        this.routerViewActive = true
      })
    }
  },
  computed: {
    header() {
      return PcHeader
    },

  }
}
</script>

<style lang="less">
html,
body,
#app{
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

</style>
